import loginMemberTemplate from './login_member.html';
import loginModalFormTemplate from '../../core/_templates/login_modal_form.html';
import companyFormModalTemplate from '../../core/_templates/pick_company_modal_form.html';

import LoginMemberCtrl from './login_member.controller';
import PickCompanyCtrl from './pick_company.controller';

function LoginMemberDirective($uibModal, $rootScope, MemberLoginService, $q, $sessionStorage, halClient) {
    'ngInject';

    const link = function (scope, element, attrs) {
        if (!$rootScope.bb) {
            $rootScope.bb = {};
        }
        if (!$rootScope.bb.api_url) {
            $rootScope.bb.api_url = scope.apiUrl;
        }
        if (!$rootScope.bb.api_url) {
            $rootScope.bb.api_url = 'http://www.bookingbug.com';
        }

        const loginModal = function () {
            const modalInstance = $uibModal.open({
                templateUrl: loginModalFormTemplate.id,
                controller: LoginMemberCtrl,
                resolve: {
                    company_id() {
                        return scope.companyId;
                    }
                }
            });
            return modalInstance.result.then((result) => {
                    scope.memberEmail = result.email;
                    scope.memberPassword = result.password;
                    if (result.$has('members')) {
                        return result.$get('members').then((members) => {
                            scope.members = members;
                            return $q.all(Array.from(members).map(m => m.$get('company'))).then(companies => pickCompanyModal(companies));
                        });
                    } else {
                        return scope.member = result;
                    }
                }
                , () => loginModal());
        };

        const pickCompanyModal = function (companies) {
            const modalInstance = $uibModal.open({
                templateUrl: companyFormModalTemplate.id,
                controller: PickCompanyCtrl,
                resolve: {
                    companies() {
                        return companies;
                    }
                }
            });
            return modalInstance.result.then((company_id) => {
                    scope.companyId = company_id;
                    return tryLogin();
                }
                , () => pickCompanyModal());
        };

        const tryLogin = function () {
            const login_form = {
                email: scope.memberEmail,
                password: scope.memberPassword
            };
            const options =
                {company_id: scope.companyId};
            return MemberLoginService.login(login_form, options).then((result) => {
                    if (result.$has('members')) {
                        return result.$get('members').then((members) => {
                            scope.members = members;
                            return $q.all(Array.from(members).map(m => m.$get('company'))).then(companies => pickCompanyModal(companies));
                        });
                    } else {
                        return scope.member = result;
                    }
                }
                , err => loginModal());
        };


        if (scope.memberEmail && scope.memberPassword) {
            return tryLogin();
        } else if ($sessionStorage.getItem('login')) {
            let session_member = $sessionStorage.getItem('login');
            session_member = halClient.createResource(session_member);
            return scope.member = session_member;
        } else {
            return loginModal();
        }
    };

    return {
        link,
        scope: {
            memberEmail: '@',
            memberPassword: '@',
            companyId: '@',
            apiUrl: '@',
            member: '='
        },
        transclude: true,
        templateUrl: loginMemberTemplate.id 
    };
}

angular
    .module('BBMember')
    .directive('loginMember', LoginMemberDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/login-member/login_member.directive.js